import { useEffect } from "react"
import { setDocumentTitle } from "shared/util"

import { useTenant } from "features/tenant/context"
import { useSideMenu } from "components/sideMenu/container"
import { useTopBar } from "components/topBar/container"

type ConventionListPageProps = {
  topBarState: ReturnType<typeof useTopBar>
  sideMenuState: ReturnType<typeof useSideMenu>
}
export const ConventionListPage = ({
	topBarState: { setBreadCrumbs },
	sideMenuState: { setActivePage },
}: ConventionListPageProps) => {
  const tenant = useTenant()
	useEffect(
    () => {
      setBreadCrumbs([{ label: '学会' }])
      setDocumentTitle('学会一覧', tenant.tenantName)
			setActivePage('convention')
    },
    [tenant, setBreadCrumbs, setActivePage]
  )
	return <></>
}